import { ContentStatus, ContentSetActions } from "../../types/content.types";

export const ContentList=function(props:{isLoggedIn:boolean, contentStatus:ContentStatus, userContentList:string[], actionClick:(action:ContentSetActions, contentSet: string) => void}){

    if(props.isLoggedIn===false)return null;
    if(props.userContentList.length===0)return null;

    let statusMsg='';
    if(props.contentStatus===ContentStatus.GetList)statusMsg="Loading ...";
    if(props.contentStatus===ContentStatus.GetListError)statusMsg="Error - Failed to load content list.  Try refresing browser.";
    if(statusMsg!=='')return <p className="teachers-statusmessage">{statusMsg}</p>

    let mySets=props.userContentList.map((contentSet:string, index:number)=>{
        let cleanContentSet=contentSet.replace(/_/g, ' ');
        return (
            <li key={contentSet+'-'+index} className='teachers-task-listitem teachers-contentlist-fullitem'>
                <span className='teachers-listitem-name'>{cleanContentSet}</span>
                <div className='teachers-listitem-buttons'>
                    <button className='teachers-listitem-button teachers-listitem-button-view' onClick={()=>{props.actionClick(ContentSetActions.View,contentSet);}}>View Info</button>
                    <button className='teachers-listitem-button teachers-listitem-button-open' onClick={()=>{props.actionClick(ContentSetActions.Open,contentSet);}}>Open Page</button>
                    <button className='teachers-listitem-button teachers-listitem-button-delete' onClick={()=>{props.actionClick(ContentSetActions.Delete,contentSet);}}>Delete</button>
                </div>
            </li>
        );
    });

    let mySimpleButtons=props.userContentList.map((contentSet:string, index:number)=>{
        let cleanContentSet=contentSet.replace(/_/g, ' ');
        return (
            <button
                key={contentSet+'-simple-'+index}
                className='teachers-button teachers-button-light teachers-contentlist-simplebutton'
                onClick={()=>{props.actionClick(ContentSetActions.View,contentSet);}}>
                {cleanContentSet}
            </button>
        );
    });

    return(
        <>
            <hr />
            <h3>Your content</h3>
            <ul id='teachers-tasks-list'>
                {mySets}
            </ul>
            <div className='teachers-contentlist-simple'>
                {mySimpleButtons}
            </div>
        </>
    )
};
